import type { IAlias } from '../model/IAlias'
import { getPersonAliasFormatted } from './getPersonAliasFormatted'

export function getPersonAliasesFormatted(aliases: IAlias[]) {
	return (
		<>
			{...aliases.map((it, index) => (
				<>
					{index > 0 ? ', ' : ''}
					{getPersonAliasFormatted(it)}
				</>
			))}
		</>
	)
}
